<script>
import Endpoints from '../../components/common/Endpoints'
import Common from '../../components/common/Common'
import Request from '../../components/common/Request'

export default {
    init: () => {
        const el = document.body
        el.removeAttribute('class')
        $('.modal').modal('hide')
    },
    methods: {
        save: function () {
            $('#spinner').modal('toggle')
            this.errors = []
            this.messageIdToast = null
            let state = this

            let data = JSON.parse(JSON.stringify(this.data))
            data.status = 'ACTIVE'
            data.date = new Date()

            // let formData = new FormData()
            console.log('SAVE BANNER', data)

            // formData.append('file', this.file)
            // formData.append('jsonData', JSON.stringify(data))
            Request.do(
                this,
                this.data._id ? 'PUT' : 'POST',
                Request.getDefaultHeader(this),
                // formData,
                data,
                `${Endpoints.banners.banner}${this.data._id ? this.data._id : ''}`,
                response => {
                    //SUCCESS CALLBACK
                    $('#spinner').modal('toggle')
                    if (!data._id) {
                        this.flashMessage.success(this.configMessage(this.$t('string.msg.trucker.register.title.success'), this.$t('string.msg.trucker.register.message.success'), 'top left', 3000), {
                            mounted: this.showText(this.$t('string.msg.trucker.register.message.success')),
                            destroyed: this.clearText(),
                        })
                    } else {
                        this.flashMessage.info(this.configMessage(this.$t('string.msg.trucker.register.title.alter'), this.$t('string.msg.trucker.register.message.alter'), 'top left', 3000), {
                            mounted: this.showText(this.$t('string.msg.trucker.register.message.alter')),
                            destroyed: this.clearText(),
                        })
                    }
                    state.data.bannerURL = response.result.bannerURL
                    state.data._id = response.result._id
                    state.valuekey += 1
                },
                error => {
                    //ERROR CALLBACK
                    $('#spinner').modal('toggle')
                    let res = error.response
                    if (res && res.status) {
                        this.titleToast = this.$t('string.msg.warning')

                        if (res.data.messageId === 'response.msg.error.empty.fields') {
                            let fields = ''
                            res.data.errors.forEach(function (value) {
                                fields += state.$t(value.id) + ';<br/>'
                            })
                            this.titleToast = this.$t(res.data.messageId)
                            this.messageToast = this.$t(fields)
                        } else {
                            this.messageToast = this.$t(res.data.messageId)
                            this.messageIdToast = res.data.messageId
                        }

                        $('#toast').modal('show')
                    }
                },
            )
        },
        handleFileUpload() {
            this.file = this.$refs.file.files[0]

            const reader = new FileReader();

            if (this.file.size > 200000) {
                alert('Informe uma imagem menor que 100MB');
            }

            reader.onload = (e) => {

                const img = new Image();
                img.onload = () => {
                    const width = img.naturalWidth;
                    const height = img.naturalHeight;
                    console.log(`Largura: ${width} pixels`);
                    console.log(`Altura: ${height} pixels`);
                    this.data.bannerURL = e.target.result;

                };

                img.src = e.target.result;

            };

            reader.readAsDataURL(this.file);
        },
        selectItem: function (item) {
            this.data = JSON.parse(JSON.stringify(item))

            document.body.scrollTop = 0 // For Safari
            document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
        },
        archive: function (response) {
            if (response == 1) {
                $('#spinner').modal('toggle')
                this.errors = []
                this.messageIdToast = null
                let state = this

                this.data.date = new Date()
                Request.do(
                    this,
                    'DELETE',
                    Request.getDefaultHeader(this),
                    this.data,
                    `${Endpoints.banners.delete}${this.data._id}`,
                    companyResponse => {
                        //SUCCESS CALLBACK
                        $('#spinner').modal('toggle')
                    },
                    error => {
                        //ERROR CALLBACK
                        $('#spinner').modal('toggle')
                        let res = error.response
                        if (res && res.status) {
                            this.titleToast = this.$t('string.msg.warning')
                            if (res.data.messageId === 'response.msg.error.empty.fields') {
                                let fields = ''
                                res.data.errors.forEach(function (value) {
                                    fields += state.$t(value.id) + ';<br/>'
                                })
                                this.titleToast = this.$t(res.data.messageId)
                                this.messageToast = this.$t(fields)
                            } else {
                                this.messageToast = this.$t(res.data.messageId)
                                this.messageIdToast = res.data.messageId
                            }

                            $('#toast').modal('show')
                        }
                    },
                )
            }
        },
        checkForm: function (e) {
            this.errors = []
            if (!this.data.company) {
                this.errors.push(this.$t('response.banner.register.company.required'))
            }
            if (!this.data.siteURL) {
                this.errors.push(this.$t('response.banner.register.site.url.required'))
            }
            if (this.errors.length > 0) {
                e.preventDefault()
            } else {
                this.save()
            }
        },
        showText(text) {
            this.text = text
        },
        clearText() {
            setTimeout(() => (this.text = ''), 500)
        },
        configMessage: function (title, message, position, time) {
            const config = {
                title: title,
                message: message,
                position: position,
                x: window.innerWidth / 60,
                y: window.innerHeight / 1.3,
                time: time,
            }
            return config
        },
        confirmArchive: function (item) {
            this.titleToast = this.$t('string.msg.confirm')
            this.messageToast = this.$t('response.archive.banner.confirmation')
            this.cancelText = this.$t('string.msg.cancel')
            this.yesText = this.$t('string.msg.yes')
            $('#confirmationModal').modal('show')
        },
        clearForm: function () {
            this.data = {}
            this.errors = []
        },

        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase,
    },
}
</script>
